<template>
  <v-dialog     
    v-model="pillarsModal" 
    persistent      
    max-width="800px"
  >
    <v-card>
      <v-window v-model="pillarsDetail">
        <v-window-item v-for="(theme, idx) in detail" :key="idx" :value="idx + 1">
          <!-- Title -->
          <v-card-title primary-title class="ml-3">
            <h2 
              :class="{
                'title': screenWidthXS,
                'headline': screenWidthSM || screenWidthMD || screenWidthLG || screenWidthXL
              }"
            > {{ theme.theme }} </h2>
            <v-spacer></v-spacer>
            <v-tooltip left color="pink">
              <template v-slot:activator="{ on }">
                <v-icon 
                  class="mr-4 hidden-xs-only" 
                  color="pink" 
                  style="font-size:5rem;" 
                  v-on="on" 
                  @click="openWindow(theme.tickets)"
                >
                  insert_drive_file
                </v-icon>
              </template>
              <span class="white--text font-weight-bold">Documentos</span>
            </v-tooltip>
            <v-btn icon @click="close">
              <v-icon color="grey">close</v-icon>
            </v-btn>          
          </v-card-title>

          <!-- Content -->
          <v-card-text class="pb-4">
            <v-layout row wrap align-center> 
              <!-- Arrow Back -->
              <v-flex xs1 hidden-xs-only class="text-xs-left">
                <v-btn icon @click="arrowBack" v-if="pillarsDetail > 1">
                  <v-icon large>arrow_back</v-icon>
                </v-btn>
              </v-flex>
              <!-- Description -->   
              <v-flex xs12 sm10>                    
                <p class="body-1"> {{ theme.description }} </p>  
                <v-tooltip left color="pink">
                  <template v-slot:activator="{ on }">
                    <v-icon 
                      class="mr-4 hidden-sm-and-up" 
                      color="pink" 
                      style="font-size:5rem;" 
                      v-on="on"                          
                      @click="openWindow(theme.tickets)"
                    >
                      insert_drive_file
                    </v-icon>
                  </template>
                  <span class="white--text font-weight-bold">Documentos</span>
                </v-tooltip>                  
              </v-flex>
              <!-- Arrow Forward -->
              <v-flex xs1 hidden-xs-only class="text-xs-right">
                <v-btn icon @click="arrowForward" v-if="pillarsDetail < detail.length">
                  <v-icon large>arrow_forward</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>  
          </v-card-text>

           <!-- Complete Text -->
            <v-card-actions class="text-xs-center headline white--text green" v-if=" 100 * theme.donated / theme.amount >= 100 ">
              <v-layout row wrap>
                <v-flex xs12>     
                  ¡Completada!
                </v-flex>
              </v-layout>
            </v-card-actions>
        </v-window-item>
      </v-window>
    </v-card>
  </v-dialog>
</template>

<script>
import { eventBus } from '@/main.js'

export default {
  name: 'pillars-modal',
  props: ['screen','pillarsModal','pillarsDetail','detail'],
  computed: {
    screenWidthXS() {
      return this.screen.width < 600 ? true : false;
    },
    screenWidthSM() {
      return this.screen.width > 600 && this.screen.width < 960 ? true : false;
    },
    screenWidthMD() {
      return this.screen.width > 960 && this.screen.width < 1264 ? true : false;
    },
    screenWidthLG() {
      return this.screen.width > 1264 && this.screen.width < 1904
        ? true
        : false;
    },
    screenWidthXL() {
      return this.screen.width > 1904 ? true : false;
    }
  },
  methods: {
    openWindow(link) {
      if(!link){
        alert(this.$t('popup.invoices'))
      }
      window.open(link, '_blank')
    },
    close() {
      eventBus.$emit('pillarsModalClosed', false)
    },
    arrowBack() {
      eventBus.$emit('pillarDetailChanged', -1)
    },
    arrowForward() {
      eventBus.$emit('pillarDetailChanged', +1)
    }
  },  
}
</script>